/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'jquery';

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as Routes from '../routes.js';
import * as ActiveStorage from "@rails/activestorage"
import "channels"

// External JS libraries
import $ from "jquery"

window.$ = $;
window.jQuery = $;
window.Routes = Routes;

import "popper.js"
// import "bootstrap"
import "bootstrap-datepicker"
import "select2"
import Dropzone from "dropzone"
import "cocoon-js" // if using npm cocoon-js package
import "./wallet_currency_calculation"
import "./select2_ajax"
import "../stylesheets/application.scss";
import './appointment_time_options'
// Initialize Rails libraries
Rails.start()
Turbolinks.start()
ActiveStorage.start()

// Your custom JS (converted from jQuery `document.ready` to Turbolinks-compatible)
document.addEventListener("turbolinks:load", () => {
  $('.instructions-box .instructions-box-see-more').click(function() {
    $(this).siblings('.instructions-box-more').toggle();
  });

  function toggle_web_url_field(dom) {
    if (dom.length > 0 && dom.val() === 'external') {
      $('div.hospital_web_url').show();
    } else {
      $('div.hospital_web_url').hide();
    }
  }

  let booking_type_field = $('input[name="hospital[booking_type]"]:checked');
  toggle_web_url_field(booking_type_field);

  $('input[name="hospital[booking_type]"]').change(function() {
    booking_type_field = $('input[name="hospital[booking_type]"]:checked');
    toggle_web_url_field(booking_type_field);
  }).trigger('change');

  $('.toggle-search-sidebar').on('click touchstart', function() {
    $('#search-sidebar').toggleClass('open');
  });
});
